import script from "./SyncStatusBar.vue?vue&type=script&setup=true&lang=js"
export * from "./SyncStatusBar.vue?vue&type=script&setup=true&lang=js"

import "./SyncStatusBar.vue?vue&type=style&index=0&id=2b4da4a3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b4da4a3"]])

export default __exports__